import { derivarPeriodo, parseFecha } from "../parseFecha";

// Parser puro de la factura PDF de AccuWeather -> shape transversal
//   { folio, fecha, periodo, concepto, monto, moneda, unidades }
// Anclas verificadas sobre el texto real de pdfjs (normalizado). Obligatorios (throw): folio, monto.
export const parsearAccuweatherDesdeTexto = (texto) => {
  // pdfjs mete espacios multiples entre palabras -> normalizar a un solo espacio antes de anclar.
  const t = texto.replace(/\s+/g, " ");

  // folio: "Numero de factura 178408" -> 178408. Obligatorio.
  const mFolio = t.match(/N[uú]mero de factura\s+(\d+)/);
  if (!mFolio) throw new Error("No se reconoce el formato de factura AccuWeather (falta Numero de factura)");
  const folio = mFolio[1];

  // monto: "25,00 $ USD" (coma decimal). NUNCA "Monto a Pagar 0,00 $" ni "Pagado -25,00 $" (no llevan
  // "$ USD" a la derecha). Obligatorio.
  const mMonto = t.match(/([\d.]*\d,\d{2})\s+\$\s+USD/);
  if (!mMonto) throw new Error("No se pudo leer el monto de la factura AccuWeather");
  const monto = Number(mMonto[1].replace(/\./g, "").replace(",", "."));

  // fecha: "Facturados De 2 Jul 2026" (D Mon YYYY). Best-effort.
  const mFecha = t.match(/Facturados De\s+(\d{1,2} [A-Za-z]+ \d{4})/);
  const fecha = mFecha ? parseFecha(mFecha[1]) : null;

  // concepto: "AccuWeather; Core Weather Standard; Base Fee" -> "Core Weather Standard". Best-effort.
  const mConcepto = t.match(/AccuWeather;\s*(.+?);/);
  const concepto = mConcepto ? mConcepto[1].trim() : "";

  // unidades: "Base Fee 1 25,00 $" -> 1. Best-effort.
  const mUnidades = t.match(/Base Fee\s+(\d+)\s+[\d.]*\d,\d{2}/);
  const unidades = mUnidades ? Number(mUnidades[1]) : null;

  return { folio, fecha, periodo: derivarPeriodo(fecha), concepto, monto, moneda: "USD", unidades };
};
